(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-header-replica"]) return;
  try {
    
  class AiStickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', AiStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-gif-scroll"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ml-gifs-cta]').forEach(function (link) {
  link.addEventListener('click', function (event) {
    var target =
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container') ||
      document.querySelector('form[action*="/cart/add"]');
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-video-scroll"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.muted = true;
          v.setAttribute('playsinline', '');
          var p = v.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
  }

  function initVids(root) {
    (root || document).querySelectorAll('.ml-vids').forEach(function (sec) {
      if (sec.getAttribute('data-ml-vids-ready')) { return; }
      sec.setAttribute('data-ml-vids-ready', '1');
      var scroller = sec.querySelector('.ml-vids__scroller');
      if (!scroller) { return; }
      var cards = Array.prototype.slice.call(scroller.querySelectorAll('.ml-vids__card'));
      var dotsWrap = sec.querySelector('.ml-vids__dots');
      var dots = [];
      if (dotsWrap) {
        cards.forEach(function () {
          var d = document.createElement('span');
          d.className = 'ml-vids__dot';
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function update() {
        var scrollable = scroller.scrollWidth > scroller.clientWidth + 2;
        sec.classList.toggle('is-scrollable', scrollable);
        if (!dots.length) { return; }
        var idx = 0;
        if (scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2) {
          idx = cards.length - 1;
        } else {
          var base = scroller.getBoundingClientRect().left + 20;
          var best = Infinity;
          cards.forEach(function (c, i) {
            var dist = Math.abs(c.getBoundingClientRect().left - base);
            if (dist < best) { best = dist; idx = i; }
          });
        }
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
      scroller.querySelectorAll('video').forEach(function (v) {
        if (io) { io.observe(v); } else { v.controls = true; }
      });
    });
  }

  function bootVids() { initVids(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVids);
  } else {
    bootVids();
  }
  document.addEventListener('shopify:section:load', function (e) { initVids(e.target); });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-ml-vids-cta]');
    if (!link) { return; }
    var target =
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container') ||
      document.querySelector('form[action*="/cart/add"]');
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
function roots(){return Array.prototype.slice.call(document.querySelectorAll(".nq"))}
function tabber(root,pairs){
pairs.forEach(function(p){
var a=root.querySelector(p[0]); if(!a)return;
a.addEventListener("click",function(){
pairs.forEach(function(q){
var on=q[0]===p[0], t=root.querySelector(q[0]), pn=root.querySelector(q[1]);
if(t)t.setAttribute("aria-selected",on?"true":"false"); if(pn)pn.hidden=!on;
});
});
});
}
function init(root){
if(root.getAttribute("data-nq-init"))return; root.setAttribute("data-nq-init","1");
tabber(root,[["#nq-tab-self","#nq-pn-self"],["#nq-tab-kin","#nq-pn-kin"]]);
Array.prototype.slice.call(root.querySelectorAll("[data-nq-offer]")).forEach(function(a){
a.addEventListener("click",function(e){
e.preventDefault();
var t=document.querySelector("product-info")||document.querySelector(".product__info-wrapper")||document.querySelector(".product");
if(t)t.scrollIntoView({behavior:"smooth",block:"start"});
});
});
}
function boot(){roots().forEach(init)}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
document.addEventListener("shopify:section:load",boot);
})();
;(function(){
var SEL=".nq .feats,.nq .stepcards,.nq .cards,.nq .nodoc-row,.nq .gar-list,.nq .infog figcaption";
var mq=window.matchMedia("(max-width:700px)");
function add(){
if(!mq.matches)return;
Array.prototype.forEach.call(document.querySelectorAll(SEL),function(c){
if(c.getAttribute("data-nq-swipe"))return;
if(c.scrollWidth<=c.clientWidth+12)return;
c.setAttribute("data-nq-swipe","1");
var w=document.createElement("div");w.className="nq-swipe";
c.parentNode.insertBefore(w,c);w.appendChild(c);
var h=document.createElement("span");h.className="nq-hint";h.setAttribute("aria-hidden","true");
h.innerHTML='Glissez<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 5 16 12 9 19"/></svg>';
w.appendChild(h);
var on=function(){if(c.scrollLeft>24){h.classList.add("is-off");c.removeEventListener("scroll",on)}};c.addEventListener("scroll",on,{passive:true});
});
}
document.addEventListener("DOMContentLoaded",add);window.addEventListener("load",add);
document.addEventListener("shopify:section:load",add);
if(mq.addEventListener)mq.addEventListener("change",add);
add();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vn-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
var LBL=["normal","grand","très grand"], size=0;
try{size=parseInt(localStorage.getItem("ml-size"),10)||0}catch(e){}
function roots(){return Array.prototype.slice.call(document.querySelectorAll(".vn"))}
function applySize(){
roots().forEach(function(r){if(size)r.setAttribute("data-size",size);else r.removeAttribute("data-size");
var l=r.querySelector("#vn-sizelbl");if(l)l.textContent=LBL[size];});
try{localStorage.setItem("ml-size",String(size))}catch(e){}
}
function tabber(root,pairs){
pairs.forEach(function(p){
var a=root.querySelector(p[0]); if(!a)return;
a.addEventListener("click",function(){
pairs.forEach(function(q){
var on=q[0]===p[0], t=root.querySelector(q[0]), pn=root.querySelector(q[1]);
if(t)t.setAttribute("aria-selected",on?"true":"false"); if(pn)pn.hidden=!on;
});
});
});
}
function init(root){
if(root.getAttribute("data-vn-init"))return; root.setAttribute("data-vn-init","1");
var sb=root.querySelector("#vn-sizebtn");
if(sb)sb.addEventListener("click",function(){size=(size+1)%3;applySize()});
tabber(root,[["#vn-tab-leak","#vn-dg-leak"],["#vn-tab-seal","#vn-dg-seal"]]);
tabber(root,[["#vn-tab-self","#vn-pn-self"],["#vn-tab-kin","#vn-pn-kin"]]);
Array.prototype.slice.call(root.querySelectorAll("[data-vn-offer]")).forEach(function(a){
a.addEventListener("click",function(e){
e.preventDefault();
var t=document.querySelector("product-info")||document.querySelector(".product__info-wrapper")||document.querySelector(".product");
if(t)t.scrollIntoView({behavior:"smooth",block:"start"});
});
});
applySize();
}
function boot(){roots().forEach(init)}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
document.addEventListener("shopify:section:load",boot);
})();
;(function(){
var SEL=".vn .feats,.vn .stepcards,.vn .cards,.vn .el-grid,.vn .nodoc-row,.vn .adapt,.vn .gar-list";
var mq=window.matchMedia("(max-width:700px)");
function add(){
if(!mq.matches)return;
Array.prototype.forEach.call(document.querySelectorAll(SEL),function(c){
if(c.getAttribute("data-vn-swipe"))return;
if(c.scrollWidth<=c.clientWidth+12)return;
c.setAttribute("data-vn-swipe","1");
var w=document.createElement("div");w.className="vn-swipe";
c.parentNode.insertBefore(w,c);w.appendChild(c);
var h=document.createElement("span");h.className="vn-hint";h.setAttribute("aria-hidden","true");
h.innerHTML='Glissez<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 5 16 12 9 19"/></svg>';
w.appendChild(h);
var on=function(){if(c.scrollLeft>24){h.classList.add("is-off");c.removeEventListener("scroll",on)}};c.addEventListener("scroll",on,{passive:true});
});
}
document.addEventListener("DOMContentLoaded",add);window.addEventListener("load",add);
document.addEventListener("shopify:section:load",add);
if(mq.addEventListener)mq.addEventListener("change",add);
add();
})();

  } catch(e) { console.error(e); }
})();
})();
